import { Injectable } from '@angular/core';
import AuthService from '../../../../old-crazy-web-frontend/src/app/auth/auth.service';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class Ng1StripeElementsService {
  stripeElements: any;

  constructor(private configService: ConfigService) {
    this.stripeElements = configService.getValue('StripeElements');
  }
}
